"use strict";
var $ = require("../internals/export");
var anObject = require("../internals/an-object");
var aPossiblePrototype = require("../internals/a-possible-prototype");
var objectSetPrototypeOf = require("../internals/object-set-prototype-of");
if (objectSetPrototypeOf) $({ target: "Reflect", stat: true }, {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    anObject(target);
    aPossiblePrototype(proto);
    try {
      objectSetPrototypeOf(target, proto);
      return true;
    } catch (error) {
      return false;
    }
  }
});
